export default "__VITE_ASSET__lYY$R8zZ__"